import { IDB_globalDb } from './IDB'
import type { NReports } from '../Rpts/Rpts.types'
import type { AbstractClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import {
    IDB_rowRead,
    IDB_rowsDelete,
    IDB_rowsReadAll,
    IDB_rowsWrite,
    IDB_rowWrite,
    IDB_idsReadAll,
} from './IDB.queries'

export function IDB_reportRead(reportId: number) {
    return IDB_rowRead<NReports.TDatabaseReport>(IDB_globalDb, 'reports', reportId)
}

export async function IDB_reportsDelete(logger: AbstractClientLogger, reportIds: number[]) {
    if (reportIds.length === 0) return
    await IDB_rowsDelete(IDB_globalDb, 'reports', reportIds)
    logger.log(`reports deleted from idb`, { idbIds: reportIds })
}

export function IDB_reportsReadAll() {
    return IDB_rowsReadAll<NReports.TDatabaseReport>(IDB_globalDb, 'reports')
}

export function IDB_reportsReadIds() {
    return IDB_idsReadAll<number>(IDB_globalDb, 'reports')
}

export async function IDB_reportsWrite(logger: AbstractClientLogger, reports: NReports.TDatabaseReport[]) {
    if (reports.length === 0) return
    await IDB_rowsWrite(IDB_globalDb, 'reports', reports)

    const reportClientIds = reports?.map((r) => r.clientId)
    logger.log(`reports written to idb`, { reportClientIds })
}

export async function IDB_reportWrite(logger: AbstractClientLogger, report: NReports.TDatabaseReport) {
    const idbId = await IDB_rowWrite(IDB_globalDb, 'reports', report)

    const reportClientId = report?.clientId
    logger.log(`report written to idb`, { reportClientId, idbId })

    return idbId
}
